import type { JSX } from 'react';
import { IDashboardWidgetCatalogItem } from '../../../types/IDashboardWidgetCatalogItem';
import { SystemTotalWidgetConfiguration } from './SystemTotalWidgetConfiguration';
import { DashboardWidgetType } from '@/modules/dashboards/types/DashboardWidgetType';
import { v4 } from 'uuid';
import { NumbersRounded } from '@mui/icons-material';
import { TFunction } from 'i18next';
import { DashboardWidgetCatalogItemImageColorType } from '../../widget-catalog/DashboardWidgetCatalogItemImage';
import { LayoutItem } from 'react-grid-layout';

export class SystemTotalWidgetCatalogItem implements IDashboardWidgetCatalogItem<SystemTotalWidgetConfiguration> {
  title: string;
  description: string;
  icon: JSX.Element;
  iconColor: DashboardWidgetCatalogItemImageColorType;
  id: string;
  type: DashboardWidgetType;
  configuration: SystemTotalWidgetConfiguration;
  layout: LayoutItem;

  constructor(t: TFunction) {
    this.title = t('dashboard.systemTotalWidget.title');
    this.description = t('dashboard.systemTotalWidget.description');
    this.icon = <NumbersRounded />;
    this.iconColor = 'green';
    this.id = v4();
    this.type = DashboardWidgetType.SystemTotalWidget;
    this.configuration = new SystemTotalWidgetConfiguration(t);
    this.layout = {
      h: 1,
      w: 1,
      i: v4(),
      x: 0,
      y: 0,
      maxH: 2,
      maxW: 2,
      minH: 1,
      minW: 1,
    };
  }
}
